module.exports = __webpack_public_path__ + "static/media/private-payroll-img01.0385f127.jpg";